import { ModuleConfig } from '@core/interfaces';

const config: ModuleConfig = {
  name: 'Busk',
  baseUrl: '',
  routes: [
    {
      path: '/admin/busk/forwarding',
      page: 'BuskForwarding',
      title: 'Busk Admin Forwarding',
      exact: true
    }
  ],
  requireAuthenticated: true
};

export default config;
